/**
 *
 *
 */
import React from 'react'
import { Button, DatePicker, Modal, Input, InputNumber, Row, Popconfirm, Col, Select } from 'antd'
import moment from 'moment'
import Api from '../../../Api'
import Exception from '../../../Exception'
import { KernelAdjuntosTable } from '../../Sub/Components/KernelAdjuntos'
import debounce from 'lodash.debounce'

export default class DetalleSuministroEquipo extends React.Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      ums: [],
      especiales: [],
      search: '',
      form: this.defaultForm(),
      ordenLocal: true,
    }

    this.lastEspecialesFetchId = 0
    this.fetchEspeciales = debounce(this.fetchEspeciales.bind(this), 800)
  }

  /**
   *
   */
  defaultForm = () => ({
    iId: null,
    sNumeroEconomico: '',
    sStatusValidacion: '',
    sDescripcion: '',
    sUnidadMedida: '',
    iCapacidad: '',
    dImporteMes: '',
    dImporteSemana: '',
    dImporteDia: '',
    dInicioArrendamiento: '',
    dTerminoArrendamiento: '',
  })

  /**
   * setFormValue
   *
   * @param {String} key
   * @param {Any} value
   */
  setFormValue = (key, value) => {
    this.setState({
      form: {
        ...JSON.parse(JSON.stringify(this.state.form)),
        [key]: value
      }
    })
  }

  /**
   * load
   */
  load = (id) => {
    this.setState({
      loading: true,
      visible: true,
    })

    const query = {
      equipo: {
        __returnType: 'one',
        model: 'MaqBitacoraProyectoEquipo',
        attributes: Object.keys(this.defaultForm()),
        where: { iId: id, iActivo: true },
      },

      ums: {
        model: 'AlmMedida',
        attributes: ['iId', 'sNombre'],
        where: { iActivo: true },
        group: ['sNombre'],
      },
    }

    Api.query.list(query)
      .then(({ data }) => {
        this.setState({
          loading: false,
          loadId: id,
          ums: data.ums,
          form: {
            ...this.defaultForm(),
            ...data.equipo,
          }
        })
      })
      .catch(error => {
        Exception.load(error).show()
        this.setState({ loading: false })
      })
  }

  /**
   *
   *
   */
  fetchEspeciales(search = '') {
    this.setState({
      search,
      loading: true,
      especiales: [],
    })

    this.lastEspecialesFetchId += 1
    const fetchId = this.lastEspecialesFetchId

    Api.query({
      model: 'SubOrdenPago',
      attributes: [
        'iId',
        'sEspecial',
      ],
      where: {
        iIdProveedor: Api.getProviderId(),
        ...(search.trim().length ? {sEspecial: { $like: `%${search.trim()}%` }} : {})
      },
      group: ['sEspecial'],
      order: [['sEspecial', 'ASC']]
    })
    .then(response => {
      if (this.lastEspecialesFetchId === fetchId) {
        this.setState({
          loading: false,
          especiales: response.data,
        })
      }
    })
    .catch(error => {
      this.setState({ loading: false, especiales: [] })
      Exception.load(error).show()
    })
  }

  /**
   *
   */
  cancelar = () => {
    this.setState({ loading: true })
    const eqId = this.state.form.iId
    const pdaId = this.state.form.iIdOrdenItem

    // todo: validar que que no se haya ingresado alguna factura
    // llamar a query de peridos y filtrar los que tengan factura ingresada

    const mutations = {
      items: [
        { model: 'MaqBitacoraProyectoEquipo', id: eqId, values: { iActivo: false } },
        { model: 'ComOrdenService', id: pdaId, values: { iIdUsuarioValida: null  } },
      ]
    }

    const request = Api.post('/kernel/mutator', mutations)

    request
      .then(() => {
        this.setState({ loading: false, visible: false })
        // todo: (id && ... )
        this.props.onCancel && this.props.onCancel()
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   *
   */
  onSave = () => {
    const data = JSON.parse(JSON.stringify(this.state.form))
    const id = data.iId
    if (data.iId) { delete data.iId }
    const request = Api.post('/kernel/mutator', {
      model: 'MaqBitacoraProyectoEquipo', id, values: data
    })

    request
      .then(response => {
        this.setState({ loading: false, visible: false })
        this.props.onSave && this.props.onSave(response.data)
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   *
   */
  onCancel = () => {
    this.setState({
      visible: false,
    })
  }

  /**
   * show and reset the form as new record
   *
   */
  showModal() {
    this.setState({
      loading: false,
      visible: true,
      search: '',
      ordenes: [],
      especiales: [],
      form: this.defaultForm(),
      orderId: null,
    })
  }

  /**
   * onOrderSelected
   *
   */
  onEspecialSeleccionado = (val) => {
    this.setState({
      form: {
        ...this.state.form,
        sNumeroEconomico: val,
      },
    })
  }

  /**
   *
   * @returns
   */
  footer = () => {
    const result = [
      <Button key='cerrar' onClick={this.onCancel} children='Cerrar' />
    ]

    if (this.state.loadId && this.state.form.sStatusValidacion !== 'VALIDADA') {
      result.push([
        <Popconfirm key='cancelar' title='¿Cancelar sumininstro?' onConfirm={() => this.cancelar()}>
          <Button type='danger' loading={this.state.loading} children='Cancelar suministro' />
        </Popconfirm>
      ])
    }

    if (this.state.form.sStatusValidacion !== 'VALIDADA') {
      result.push([
        <Popconfirm key='guardar' title='¿Guardar cambios?' onConfirm={this.onSave}>
          <Button type='primary' loading={this.state.loading} children='Guardar cambios' />
        </Popconfirm>
      ])
    }

    return result
  }

  /**
   * render
   */
  render() {
    const isDisabled = this.state.loadId && this.state.form.sStatusValidacion !== 'PENDIENTE'

    return (
      <Modal
        title='DETALLES DEL EQUIPO'
        style={{ top: 20 }}
        width={'60%'}
        visible={this.state.visible}
        onOk={this.onSave}
        onCancel={this.onCancel}
        footer={this.footer()}>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ minWidth: 300, width: 300, marginRight: 10 }}>
            {/* no economico */}
            <Row style={styles.row}>
              <label>NÚMERO ECONOMICO</label>
                <Input
                  disabled={isDisabled}
                  style={{ width: '100%' }}
                  value={this.state.form.sNumeroEconomico}
                  onChange={e => this.setFormValue('sNumeroEconomico', (e.target.value || '').toUpperCase())}
                />
            </Row>

            {/* descripcion */}
            <Row style={styles.row}>
              <label>DESCRIPCIÓN</label>
                <Input.TextArea
                  disabled={isDisabled}
                  style={{ width: '100%' }}
                  value={this.state.form.sDescripcion}
                  onChange={e => this.setFormValue('sDescripcion', (e.target.value || '').toUpperCase())}
                />
            </Row>

            {/* importes */}
            <Row style={styles.row}>
              {/* um */}
              <Col span={11}>
                <label>IMPORTE X MES</label>
                <InputNumber
                  disabled={isDisabled}
                  style={{ width: '100%' }}
                  value={this.state.form.dImporteMes}
                  onChange={val => this.setFormValue('dImporteMes', val ? val.toString() : '')}
                />
              </Col>

              <Col span={2} />

              {/* - */}
              <Col span={11}>

              </Col>
            </Row>

            {/* capacidad */}
            <Row style={styles.row}>
              {/* um */}
              <Col span={11}>
                <label>CANT CAPACIDAD</label>
                <InputNumber
                  disabled={isDisabled}
                  style={{ width: '100%' }}
                  value={this.state.form.iCapacidad}
                  onChange={val => this.setFormValue('iCapacidad', val ? val.toString() : '')}
                />
              </Col>

              <Col span={2} />

              {/* cap */}
              <Col span={11}>
                <label>U.M. CAPACIDAD</label>

                <Select
                  disabled={isDisabled}
                  style={{ width: '100%' }}
                  filterOption={false}
                  onChange={val => this.setFormValue('sUnidadMedida', val ? val : '')}
                  value={this.state.form.sUnidadMedida}
                  children={this.state.ums.map((item) =>
                    <Select.Option key={item.sNombre} children={item.sNombre} />
                  )}
                />
              </Col>
            </Row>

            {/* periodo */}
            {true ? null : (
              <Row style={styles.row}>
                {/* inicio */}
                <Col span={11}>
                  <label>INICIO DE PERIODO</label>
                  <DatePicker
                    style={{ width: '100%' }}
                    value={this.state.form.dInicioPeriodo ? moment(this.state.form.dInicioPeriodo, 'YYYY-MM-DD') : null}
                    // onChange={date => date ? this.setFormValue('dInicioPeriodo', date.format('YYYY-MM-DD')) : undefined}
                  />
                </Col>

                <Col span={2} />

                {/* termino */}
                <Col span={11}>
                  <label>TERMINO DE PERIODO</label>
                  <DatePicker
                    style={{ width: '100%' }}
                    value={this.state.form.dTerminoPeriodo ? moment(this.state.form.dTerminoPeriodo, 'YYYY-MM-DD') : null}
                    // onChange={date => date ? this.setFormValue('dTerminoPeriodo', date.format('YYYY-MM-DD')) : undefined}
                  />
                </Col>
              </Row>
            )}
          </div>

          {!this.state.loadId ? null : (
            <div>
              <KernelAdjuntosTable
                model='MaqBitacoraProyectoEquipo'
                docId={this.state.loadId}
                statusField='sStatusValidacion'
                allowStatus='PENDIENTE'
              />
            </div>
          )}
        </div>
      </Modal>
    )
  }
}

const styles = {
  row: {
    marginBottom: 10,
  }
}
